// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>

console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

// Contact Form Vue App
// import { createApp } from "vue";
import { createApp } from 'vue/dist/vue.esm-bundler';
import VueAxios from "vue-axios";
import axios from "axios";
import ContactForm from "../../views/front/vue_components/contact_form/ContactForm.vue";
import EarringContactForm from "../../views/front/vue_components/earring_form/EarringContactForm.vue";
import PendantContactForm from "../../views/front/vue_components/pendant_form/PendantContactForm.vue";
import PieceContactForm from "../../views/front/vue_components/piece_form/PieceContactForm.vue";
import RingContactForm from "../../views/front/vue_components/ring_form/RingContactForm.vue";
import MoissaniteContactForm from "../../views/front/vue_components/moissanite_form/MoissaniteContactForm.vue";
import DiamondContactForm from "../../views/front/vue_components/diamond_form/DiamondContactForm.vue";
import LabGrownDiamondContactForm from "../../views/front/vue_components/lab_grown_diamond_form/LabGrownDiamondContactForm.vue";
import Cart from "../../views/front/vue_components/cart/Cart.vue";
import TestApp from "../components/TestApp.vue"

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
if (csrfToken) axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;

// createApp(TestApp).mount('#test-app')
// createApp(ContactForm).use(VueAxios, axios).mount('#contact-form-app')
// createApp(EarringContactForm).use(VueAxios, axios).mount('#earring-enquiry-form')

function mountVueComponent(selector, component) {
    const target = document.querySelector(selector);
    if (!target) return;

    const source = target.firstElementChild;
    const props = {};
    if (source) {
        for (const attribute of source.attributes) {
            props[attribute.name] = ['item', 'cart'].includes(attribute.name)
                ? Number(attribute.value)
                : attribute.value;
        }
    }

    const app = createApp(component, props);
    app.use(VueAxios, axios);
    app.mount(target);
}

mountVueComponent('#contact_form_app', ContactForm);
mountVueComponent('#earring_enquiry_form', EarringContactForm);
mountVueComponent('#pendant_enquiry_form', PendantContactForm);
mountVueComponent('#piece_enquiry_form', PieceContactForm);
mountVueComponent('#ring_enquiry_form', RingContactForm);
mountVueComponent('#moissanite_enquiry_form', MoissaniteContactForm);
mountVueComponent('#diamond_enquiry_form', DiamondContactForm);
mountVueComponent('#lab_enquiry_form', LabGrownDiamondContactForm);

// Shop & Cart Vue Components
mountVueComponent('#cart_app', Cart);

document.querySelectorAll('input[type="file"][data-max-files]').forEach((input) => {
    input.addEventListener('change', () => {
        const maxFiles = Number(input.dataset.maxFiles);
        if (input.files.length <= maxFiles) return;

        input.value = '';
        window.alert(`Please select no more than ${maxFiles} images.`);
    });
});